export default "__VITE_ASSET__DtMDqfFh__"